import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'empresaPciDocs'

const Get = (companyId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${companyId}`, data, config)
const UpdatePermissions = (companyId, data = [], config = {}) => APIClient.post(`${APIPci}/${resourceName}/${companyId}`, data, config)
const UpdatePermissionsByUser = (userID, companyId, data = [], config = {}) => APIClient.post(`${APIPci}/${resourceName}/usuario/${userID}/empresa/${companyId}`, data, config)
const UpdatePermissionsByGroup = (groupID, companyId, data = [], config = {}) => APIClient.post(`${APIPci}/${resourceName}/grupo/${groupID}/empresa/${companyId}`, data, config)

const CompanyPciDocsRepository = {
  Get,
  UpdatePermissions,
  UpdatePermissionsByUser,
  UpdatePermissionsByGroup
}

export default CompanyPciDocsRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/companyPciDocs.js